<template>
  <pt-detection-new class="pt-detection-new__page"></pt-detection-new>
</template>

<script>
import PtDetectionNew from 'cps/gene-product/pt-detection-new/withData'
export default {
  name: 'pt-detection-new__view',
  components: {
    'pt-detection-new': PtDetectionNew
  }
}
</script>
